import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { StorageLocationsResponse } from 'src/apis/storage/types';
import type { StorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { useAxios, type Successful } from 'src/hooks/use-axios';
import { NotFound } from 'src/utils/errors';

type HookProps = {
  storageServiceRoot: Successful<StorageServiceRootRequest>;
};

type ExecuteProps = {
  url: string;
};

export function usePublicStorageLocations({ storageServiceRoot }: HookProps) {
  const storageLocations = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<StorageLocationsResponse>({ ...baseConfig, url }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!storageServiceRoot.response.data._links?.getLocationsOverview) {
      throw new NotFound();
    }
    const templatedUrl = urlTemplate
      .parse(storageServiceRoot.response.data._links.getLocationsOverview.href)
      .expand({});

    storageLocations.execute({
      url: templatedUrl,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [storageServiceRoot.response]);

  return storageLocations;
}

export type PublicStorageLocationsRequest = ReturnType<
  typeof usePublicStorageLocations
>;
